const styles = {
	item: { fontFamily: 'Open Sans', color: '#646b6f', fontSize: '16px' },
	labelItem: { fontWeight: 'bold' }
};

export default styles;



// WEBPACK FOOTER //
// ./src/main/webapp/media/scripts/webpack/mainNav/components/SocialChatMenu/styles.js